import { useEffect, useState } from "react";
import { userInformationService } from "../../_services/userInformation.service";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";

export function UserProfileProfileImageView(params: { userId: string }) {

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState();


    useEffect(() => {
        if (params.userId)
            fetchData(params.userId);
    }, []);

    function fetchData(id: string) {

        setIsLoading(true)
        return userInformationService
            .getProfileImage(id)
            .then(
                (json) => {
                    setData(json);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <>
            {data &&
                <img id="profileImg" style={{
                    width: "120px",
                    maxHeight: "120px",
                    marginTop: "10px",
                    display: 'block',
                    objectFit: "cover",
                    marginRight: 'auto',
                    marginBottom: "10px"
                }} src={"data:image/jpeg;charset=utf-8;base64," + data} alt={"Profile Image"}></img>
            }
        </>
    );

}
